/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/9/2022
 */

export const ObjectTypeEnum = Object.freeze({

	WHEEL_OF_LIFE: "WHEEL_OF_LIFE",
	QWOACH_EVENT: "QWOACH_EVENT",
	CLIENT: "CLIENT",
	PROSPECT: "PROSPECT",
	COACHING_PACKAGE_TEMPLATE: "COACHING_PACKAGE_TEMPLATE",
	COACHING_PACKAGE: "COACHING_PACKAGE",
	COACHING_PACKAGE_GROUP: "COACHING_PACKAGE_GROUP",
	WHEEL_ANSWER: "WHEEL_ANSWER",
})
